import { render, staticRenderFns } from "./crawlpageAddTagsComponent.vue?vue&type=template&id=3ecac8ef&"
import script from "./crawlpageAddTagsComponent.vue?vue&type=script&lang=js&"
export * from "./crawlpageAddTagsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports